module.exports = __webpack_public_path__ + "static/media/icon_51.5e516bf0.svg";